


















































































































































































































import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Directory } from "../../../domain/drawing";
import {
  FormatReference,
  FormatSet,
  WriteMethodTypeValue,
} from "../../../domain/format";
import { IRectangle } from "../../../domain/system";
import {
  instanceOfITreeExpandable,
  DialogSelector,
  IDialogCondition,
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
  instanceOfITreeCollapsable,
} from "../../system";
import { instanceOfICancelSelectFormatTree } from "./trees/ICancelSelectFormatTree";
import { instanceOfIEditFormatTree } from "./trees/IEditFormatTree";
import Empty from "../../system/EmptyComponent.vue";
import { ModelEditableMixin } from "../../system/mixins";
import {
  ITreeSource,
  CommonDepartmentFavoriteFormatTreeSource,
  DepartmentFavoriteFormatTreeSource,
  DepartmentFavoriteFormatSetTreeSource,
  FormatSetTreeSource,
  FormatTreeSource,
  UserFavoriteFormatSetTreeSource,
  UserFavoriteFormatTreeSource,
  ITreeRootSource,
  FilterableFormatTreeSource,
  IFormatTreeSourceFilterable,
  instanceOfIEditTreeSource,
  instanceOfIEditTreeRootSource,
} from "./trees/sources";
import TabSelector from "../../system/selectors/TabSelector.vue";
import { FormatReferenceTreeFilterParameter, FormatSetTreeFilter, FormatSetTreeFilterParameter } from "../filters";
import { StringFilterParameter } from "../../system/filters";
import { IGeometryManageable } from "../../system/utilities";
import FormatReferenceTreeFilter from "../filters/FormatReferenceTreeFilter.vue";
import FormatReferencesSelector from "./trees/FormatReferencesSelector.vue";
import FormatSetReferencesSelector from "./trees/FormatSetReferencesSelector.vue";
import Separator from "../../system/Separator.vue";
import { IDepartmentDialogCondition } from "../../department/dialogs";
import { IConfiguration } from "../../../domain/configuration";
import { Department } from "../../../domain/department";

interface IFormatsSelectorGeometry extends IRectangle {
  formatsSelector?: {
    selector: {
      width: number;
    };
  };
}

@Component({
  components: {
    TabSelector,
    FormatReferenceTreeFilter,
    FormatReferencesSelector,
    FormatSetTreeFilter,
    FormatSetReferencesSelector,
    Empty,
    Separator,
    DialogSelector,
  }
})
export default class FormatsSelector extends Mixins(ModelEditableMixin) implements IGeometryManageable<IFormatsSelectorGeometry> {
  // TODO: 型を定義したい
  static readonly Tabs: {[key: string]: any} = {
    allFormats: {
      name: "すべて",
      description: "すべてのフォーマットから選択します。",
      componentName: "allFormatsSelector",
      keyword: "all",
    },
    commonDepartmentFavoriteFormats: {
      name: "全科頻用",
      description: "全診療科でよく利用するフォーマットから選択します。",
      componentName: "commonDepartmentFavoriteFormatsSelector",
      keyword: "commonDepartment",
    },
    departmentFavoriteFormats: {
      name: "科　頻用",
      description: "診療科でよく利用するフォーマットから選択します。",
      componentName: "departmentFavoriteFormatsSelector",
      keyword: "department",
    },
    userFavoriteFormats: {
      name: "個人頻用",
      description: "ユーザがよく利用するフォーマットから選択します。",
      componentName: "userFavoriteFormatsSelector",
      keyword: "user",
    },
    allFormatSets: {
      name: "文書セット",
      description: "共通の文書セットのフォーマットから選択します。",
      componentName: "formatSetSelector",
      keyword: "commonDepartmentFormatSet",
    },
    departmentFavoriteFormatSets: {
      name: "科　文書セット",
      description: "診療科の文書セットのフォーマットから選択します。",
      componentName: "departmentFavoriteFormatSetSelector",
      keyword: "departmentFormatSet",
    },
    userFavoriteFormatSets: {
      name: "個人文書セット",
      description: "個人の文書セットのフォーマットから選択します。",
      componentName: "userFavoriteFormatSetSelector",
      keyword: "userFormatSet",
    },
    loading: {
      name: "起動中",
      description: "起動中にローディング表示するための定義なので実際にこれをタブには表示しないでください。",
      componentName: "Empty",
    }
  };
  static readonly formatTabs: any[] = [
    FormatsSelector.Tabs.allFormats,
    FormatsSelector.Tabs.commonDepartmentFavoriteFormats,
    FormatsSelector.Tabs.departmentFavoriteFormats,
    FormatsSelector.Tabs.userFavoriteFormats,
  ];
  static readonly formatSetTabs: any[] = [
    FormatsSelector.Tabs.allFormatSets,
    FormatsSelector.Tabs.departmentFavoriteFormatSets,
    FormatsSelector.Tabs.userFavoriteFormatSets,
  ];
  static readonly allTabs: any[] = FormatsSelector.formatTabs.concat(FormatsSelector.formatSetTabs);

  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly allFormatsTab: any = FormatsSelector.Tabs.allFormats;
  readonly commonDepartmentFavoriteFormatsTab: any = FormatsSelector.Tabs.commonDepartmentFavoriteFormats;
  readonly departmentFavoriteFormatsTab: any = FormatsSelector.Tabs.departmentFavoriteFormats;
  readonly userFavoriteFormatsTab: any = FormatsSelector.Tabs.userFavoriteFormats;
  readonly allFormatSetsTab: any = FormatsSelector.Tabs.allFormatSets;
  readonly departmentFavoriteFormatSetsTab: any = FormatsSelector.Tabs.departmentFavoriteFormatSets;
  readonly userFavoriteFormatSetsTab: any = FormatsSelector.Tabs.userFavoriteFormatSets;
  readonly loadingTab: any = FormatsSelector.Tabs.loading;

  @Prop({ default: null })
  isReady: boolean;

  // 本来であれば、使う側で拡張できる仕組み(外からコンテンツを差し込めるようにする等)で検討したい所.
  // 今からそう直すのは実際に活用されるユースケースを考えるとコストに見合わないように思われるため、
  // 最大機能(タブとコンテンツ)を実装して、プロパティで必要な機能に絞って利用するよう実装する.
  // あまりいいパターンではないので真似しない事.
  @Prop()
  visibleTabs: any[];

  @Prop({ default: null })
  formatId: number;

  @Prop({ default: null })
  formatName: string;

  @Prop()
  formatTreeSourceFilter: IFormatTreeSourceFilterable;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop({ default: false })
  containsExpired: boolean;

  @Prop({ default: false })
  containsDeleted: boolean;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: null })
  defaultWriteMethodTypes: WriteMethodTypeValue[];

  @Prop({ default: false })
  shouldIncludeReferenceableGroupFormats: boolean;

  get allFormatTreeSource(): ITreeSource<FormatReference> {
    return this.createFilterableFormatTreeSource(new FormatTreeSource(this.shouldIgnoreChained, this.shouldIncludeReferenceableGroupFormats));
  }

  get commonDepartmentFavoriteFormatTreeSource(): ITreeSource<FormatReference> {
    return this.createFilterableFormatTreeSource(new CommonDepartmentFavoriteFormatTreeSource(this.shouldIgnoreChained, this.shouldIncludeReferenceableGroupFormats));
  }

  get departmentFavoriteFormatTreeSource(): ITreeSource<FormatReference> {
    return this.createFilterableFormatTreeSource(new DepartmentFavoriteFormatTreeSource(this.selectedDepartmentId, this.shouldIgnoreChained, this.shouldIncludeReferenceableGroupFormats));
  }

  get userFavoriteFormatTreeSource(): ITreeSource<FormatReference> {
    const userId = this.$store.getters.user.id;
    return this.createFilterableFormatTreeSource(new UserFavoriteFormatTreeSource(userId, this.shouldIgnoreChained, this.shouldIncludeReferenceableGroupFormats));
  }

  private createFilterableFormatTreeSource(treeSource: ITreeSource<FormatReference>): ITreeSource<FormatReference> {
    // ツリー編集にはIEditTreeSourceが必要となる
    return !!this.formatTreeSourceFilter
      ? new FilterableFormatTreeSource(treeSource, this.formatTreeSourceFilter)
      : treeSource;
  }

  get formatSetTreeSource(): ITreeRootSource<FormatSet> {
    return new FormatSetTreeSource(this.shouldIgnoreChained);
  }

  get departmentFavoriteFormatSetTreeSource(): ITreeRootSource<FormatSet> {
    return new DepartmentFavoriteFormatSetTreeSource(this.selectedDepartmentId, this.shouldIgnoreChained);
  }

  get userFavoriteFormatSetTreeSource(): ITreeRootSource<FormatSet> {
    const userId = this.$store.getters.user.id;
    return new UserFavoriteFormatSetTreeSource(userId, this.shouldIgnoreChained);
  }

  get visibleSelectorTabs(): any[] {
    return Enumerable.from(this.selectorTabs)
      .where(t => !this.visibleTabs || Enumerable.from(this.visibleTabs).any(vt => vt.name === t.name))
      .where(t => this.isVisibleTabByConfiguration(t))
      .toArray();
  }

  private isVisibleTabByConfiguration(tab: any): boolean {
    if (!tab) { return false; }
    const configuration = this.$configuration.behavior.format.selector.tab;
    const formatSet = this.$configuration.behavior.format.formatSet.tab;
    // 検索条件に指定するダイアログでは「すべて」が表示できたほうがよいため、ここではallは判定しない
    switch (tab.keyword) {
      case "commonDepartment": return configuration.commonDepartment.isEnable;
      case "department": return configuration.department.isEnable;
      case "user": return configuration.user.isEnable;
      case "commonDepartmentFormatSet": return formatSet.commonDepartment.isEnable;
      case "departmentFormatSet": return formatSet.department.isEnable;
      case "userFormatSet": return formatSet.user.isEnable;
    }
    return true;
  }

  get isDocumentKindSpecified(): boolean {
    return !!this.documentKindIds && Enumerable.from(this.documentKindIds).any(d => !isNaN(d));
  }

  get isFormatSetTabSelected(): boolean {
    return !!this.selectedSelectorTab && FormatsSelector.formatSetTabs.some(t => t === this.selectedSelectorTab);
  }

  get shouldExpandTreeAutomatically(): boolean {
    return !this.$configuration.behavior.format.selector.shouldExpandTreeAutomatically;
  }

  data(): any {
    const selectorTabs = [
      FormatsSelector.Tabs.allFormats,
      FormatsSelector.Tabs.commonDepartmentFavoriteFormats,
      FormatsSelector.Tabs.departmentFavoriteFormats,
      FormatsSelector.Tabs.userFavoriteFormats,
      FormatsSelector.Tabs.allFormatSets,
      FormatsSelector.Tabs.departmentFavoriteFormatSets,
      FormatsSelector.Tabs.userFavoriteFormatSets,
    ];
    const documentKindIds = !!this.documentKindIds
      ? Enumerable.from(this.documentKindIds).where(d => !isNaN(d)).toArray()
      : [];
    const writeMethodTypes = !!this.defaultWriteMethodTypes
      ? this.defaultWriteMethodTypes
      : [];
    const initializer = (documentKindIds.length === 0 && writeMethodTypes.length === 0)
      ? null
      : (p: FormatReferenceTreeFilterParameter) => {
        p.reference.documentKinds = Enumerable.from(documentKindIds).select(d => new StringFilterParameter(d.toString(), false)).toArray();
        p.reference.writeMethodTypes = Enumerable.from(writeMethodTypes).select(w => new StringFilterParameter(w, false)).toArray();
      };

    const initialFormatFilter = new FormatReferenceTreeFilterParameter(initializer);
    initialFormatFilter.clear();
    if (this.formatName && this.formatName !== "") {
      initialFormatFilter.reference.name.keyword = this.formatName;
    }
    const initialFormatSetFilter = new FormatSetTreeFilterParameter();
    initialFormatSetFilter.clear();
    if (this.formatName) {
      initialFormatSetFilter.set.formatName.keyword = this.formatName;
    }
    return {
      selectorTabs,
      selectedSelectorTab: FormatsSelector.Tabs.loading,
      formatFilter: initialFormatFilter,
      formatSetFilter: initialFormatSetFilter,
      formatFavoriteFilter: new FormatReferenceTreeFilterParameter(), // 使用されていないように見えるので削除したい
      selectionOfAllFormats: [],
      selectionOfCommonDepartmentFavoriteFormats: [],
      selectionOfDepartmentFavoriteFormats: [],
      selectionOfUserFavoriteFormats: [],
      selectionOfAllFormatSets: [],
      selectionOfDepartmentFavoriteFormatSets: [],
      selectionOfUserFavoriteFormatSets: [],
      selectedFormatSetOfAllFormatSets: null,
      selectedFormatSetOfDepartmentFavoriteFormatSets: null,
      selectedFormatSetOfUserFavoriteFormatSets: null,
      selectionOfAllHashTableDirectoryPathForEachFormat: [],
      selectionOfCommonDepartmentFavoriteHashTableDirectoryPathForEachFormat: [],
      selectionOfDepartmentFavoriteHashTableDirectoryPathForEachFormat: [],
      selectionOfUserFavoriteHashTableDirectoryPathForEachFormat: [],
      isTreeSelecting: false,
      createdTabs: [],
      selectorWidth: 480,
      expandFilter: false,
      isFormatsLoadCompleted: false,
      selectedDepartmentOfFavoriteFormatsTab: this.$store.getters.department,
      selectedDepartmentOfFormatSetsTab: this.$store.getters.department,
    };
  }
  selectorTabs: any[];
  selectedSelectorTab: any;
  formatFilter: FormatReferenceTreeFilterParameter;
  formatSetFilter: FormatSetTreeFilterParameter;
  formatFavoriteFilter: FormatReferenceTreeFilterParameter; // 使用されていないように見えるので削除したい
  // 各selector用のmodelを別に持つ.冗長すぎるが...v-model双方向バインディングやめてコンポーネント側の情報/変化を取れるI/Fの方がいいかも.必要なら見直し.
  selectionOfAllFormats: FormatReference[];
  selectionOfCommonDepartmentFavoriteFormats: FormatReference[];
  selectionOfDepartmentFavoriteFormats: FormatReference[];
  selectionOfUserFavoriteFormats: FormatReference[];
  selectionOfAllFormatSets: FormatReference[];
  selectionOfDepartmentFavoriteFormatSets: FormatReference[];
  selectionOfUserFavoriteFormatSets: FormatReference[];
  selectedFormatSetOfAllFormatSets: FormatSet;
  selectedFormatSetOfDepartmentFavoriteFormatSets: FormatSet;
  selectedFormatSetOfUserFavoriteFormatSets: FormatSet;
  selectionOfAllHashTableDirectoryPathForEachFormat: { [key: number]: string };
  selectionOfCommonDepartmentFavoriteHashTableDirectoryPathForEachFormat: { [key: number]: string };
  selectionOfDepartmentFavoriteHashTableDirectoryPathForEachFormat: { [key: number]: string };
  selectionOfUserFavoriteHashTableDirectoryPathForEachFormat: { [key: number]: string };
  isTreeSelecting: boolean;
  createdTabs: any[];
  selectorWidth: number;
  expandFilter: boolean;
  isFormatsLoadCompleted: boolean;
  selectedDepartmentOfFavoriteFormatsTab: Department;
  selectedDepartmentOfFormatSetsTab: Department;

  get favoriteFormatsDepartmentChangeDescription(): string {
    return "頻用を表示する" + this.$wording.common.department + "です。所属" + this.$wording.common.department + "から選択できます。";
  }

  get formatsSetDepartmentChangeDescription(): string {
    return "セットを表示する" + this.$wording.common.department + "です。所属" + this.$wording.common.department + "から選択できます。";
  }

  get departmentChangeLabel(): string {
    return this.$wording.common.department + "選択";
  }

  get hasOneUserDepartment(): boolean {
    return this.$store.getters.userDepartments && this.$store.getters.userDepartments.length === 1;
  }

  get departmentCondition(): IDepartmentDialogCondition {
    return {
      name: "対象" + this.$wording.common.department,
      isUserDepartmentsOnly: this.isUserDepartmentsOnly,
      shouldShowReferenceableGroupDepartments: this.shouldIncludeReferenceableGroupFormats,
    };
  }

  /**
   * 過去一覧のフォーマット検索ダイアログ内では所属診療科以外の科頻用も選択できたほうが良いのだが、
   * 判定材料としてshouldIncludeReferenceableGroupFormatsがぴったり一致するので流用している
   * 必要あればisUserDepartmentsOnly等をProp経由で渡すことを検討する
   */
  get isUserDepartmentsOnly(): boolean {
    return !this.shouldIncludeReferenceableGroupFormats;
  }

  get departmentDialog(): ISingleSelectableAsynchronously<Department> & ISingleSelectableConditionallyAsynchronously<Department, IDialogCondition> {
    return this.$commonDialogs.department.buttonSelector;
  }

  get isFavoriteFormatsDepartmentSelectable(): boolean {
    return this.$configuration.behavior.format.selector.tab.department.isDepartmentSelectable;
  }

  get isFormatsSetDepartmentSelectable(): boolean {
    return this.$configuration.behavior.format.formatSet.tab.department.isDepartmentSelectable;
  }

  get loginDepartment(): Department {
    return this.$store.getters.department;
  }

  get selectedDepartment(): Department {
    return this.shouldShowContent(this.departmentFavoriteFormatsTab)
      ? this.selectedDepartmentOfFavoriteFormatsTab
      : this.shouldShowContent(this.departmentFavoriteFormatSetsTab)
        ? this.selectedDepartmentOfFormatSetsTab
        : this.loginDepartment;
  }

  set selectedDepartment(value: Department) {
    if (!this.isFavoriteFormatsDepartmentSelectable) {
      this.selectedDepartmentOfFavoriteFormatsTab = value;
    }
    if (!this.isFormatsSetDepartmentSelectable) {
      this.selectedDepartmentOfFormatSetsTab = value;
    }
  }

  get selectedDepartmentId(): string {
    return this.selectedDepartment ? this.selectedDepartment.id : null;
  }

  @Watch("loginDepartment")
  onLoginDepartmentUpdated(newValue: Department): void {
    this.selectedDepartment = newValue;
  }

  getSelectedFormats(): FormatReference[] {
    // ここも当然冗長になるが必要なら別途見直し.
    if (this.selectedSelectorTab) {
      if (this.selectedSelectorTab === FormatsSelector.Tabs.allFormats) {
        return this.selectionOfAllFormats;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.commonDepartmentFavoriteFormats) {
        return this.selectionOfCommonDepartmentFavoriteFormats;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.departmentFavoriteFormats) {
        return this.selectionOfDepartmentFavoriteFormats;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.userFavoriteFormats) {
        return this.selectionOfUserFavoriteFormats;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.allFormatSets) {
        return this.selectionOfAllFormatSets;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.departmentFavoriteFormatSets) {
        return this.selectionOfDepartmentFavoriteFormatSets;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.userFavoriteFormatSets) {
        return this.selectionOfUserFavoriteFormatSets;
      }
    }
    return [];
  }

  getHashTableDirectoryPathForEachFormat(): { [key: number]: string } {
    // ここも当然冗長になるが必要なら別途見直し.
    if (this.selectedSelectorTab) {
      if (this.selectedSelectorTab === FormatsSelector.Tabs.allFormats) {
        return this.selectionOfAllHashTableDirectoryPathForEachFormat;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.commonDepartmentFavoriteFormats) {
        return this.selectionOfCommonDepartmentFavoriteHashTableDirectoryPathForEachFormat;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.departmentFavoriteFormats) {
        return this.selectionOfDepartmentFavoriteHashTableDirectoryPathForEachFormat;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.userFavoriteFormats) {
        return this.selectionOfUserFavoriteHashTableDirectoryPathForEachFormat;
      }
    }
    return [];
  }

  getSelectedFormatSet(): FormatSet {
    // ここも当然冗長になるが必要なら別途見直し.
    if (this.selectedSelectorTab) {
      if (this.selectedSelectorTab === FormatsSelector.Tabs.allFormatSets) {
        return this.selectedFormatSetOfAllFormatSets;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.departmentFavoriteFormatSets) {
        return this.selectedFormatSetOfDepartmentFavoriteFormatSets;
      } else if (this.selectedSelectorTab === FormatsSelector.Tabs.userFavoriteFormatSets) {
        return this.selectedFormatSetOfUserFavoriteFormatSets;
      }
    }
    return null;
  }

  created(): void {
    this.$registerGeometryManager(this);
  }

  destroyed(): void {
    this.$unregisterGeometryManager(this);
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }

  storeGeomerty(source: IFormatsSelectorGeometry, isWindowRectangleHandleable: boolean): void {
    source.formatsSelector = {
      selector: {
        width: this.selectorWidth,
      },
    };
  }

  restoreGeomerty(source: IFormatsSelectorGeometry, isWindowRectangleHandleable: boolean): void {
    if (!source.formatsSelector) {
      return;
    }
    this.selectorWidth = source.formatsSelector.selector.width;
  }

  mounted(): void {
    // tabsがstaticのため、ここでタブの設定を読み込む
    this.setCommonDepartmentFavoriteFormatsSetting();
    this.setDepartmentFavoriteFormatsSetting();
    this.setAllFormatSetsSetting();
    this.setDepartmentFavoriteFormatSetsSetting();
    this.setUserFavoriteFormatSetsSetting();

    if (!this.folderId) {
      this.$logger.info("folderIdが指定されてません.デフォルトタブを選択します.");
      this.selectedSelectorTab = this.defaultSelectedTab;
      // 将来的にはウィンドウ高さを見て判定する機能を追加するかもだが、現状では未着手
      this.expandFilter = !this.$configuration.behavior.format.selector.collapse.shouldShrinkAutomatically;
    } else {
      this.$logger.info("folderIdが指定されてるので頻用タブを選択します.(" + this.folderId + ")");
      // タブ選択は各頻用タブからのイベントで決定.ここでは生成だけ.(マッチしない場合はタブ未選択.運用上ありえないので許容.)
      this.createPane(FormatsSelector.Tabs.commonDepartmentFavoriteFormats);
      this.createPane(FormatsSelector.Tabs.departmentFavoriteFormats);
    }
  }

  setCommonDepartmentFavoriteFormatsSetting(): void {
    FormatsSelector.Tabs.commonDepartmentFavoriteFormats.name = "全" + this.$wording.common.departmentAsShort + "頻用";
    FormatsSelector.Tabs.commonDepartmentFavoriteFormats.description = "全" + this.$wording.common.department + "でよく利用する" + this.$wording.format.name + "から選択します。";
  }

  setDepartmentFavoriteFormatsSetting(): void {
    FormatsSelector.Tabs.departmentFavoriteFormats.name = this.$wording.common.departmentAsShort + "　頻用";
    FormatsSelector.Tabs.departmentFavoriteFormats.description = this.$wording.common.department + "でよく利用する" + this.$wording.format.name + "から選択します。";
  }

  setAllFormatSetsSetting(): void {
    FormatsSelector.Tabs.allFormatSets.name = this.$wording.format.attributes.name + "セット";
    FormatsSelector.Tabs.allFormatSets.description = "共通の" + this.$wording.format.attributes.name + "セットの" + this.$wording.format.name + "から選択します。";
  }

  setDepartmentFavoriteFormatSetsSetting(): void {
    FormatsSelector.Tabs.departmentFavoriteFormatSets.name = this.$wording.common.departmentAsShort + "　" + this.$wording.format.attributes.name + "セット";
    FormatsSelector.Tabs.departmentFavoriteFormatSets.description = this.$wording.common.department + "の" + this.$wording.format.attributes.name + "セットの" + this.$wording.format.name + "から選択します。";
  }

  setUserFavoriteFormatSetsSetting(): void {
    FormatsSelector.Tabs.userFavoriteFormatSets.name = "個人" + this.$wording.format.attributes.name + "セット";
    FormatsSelector.Tabs.userFavoriteFormatSets.description = "個人の" + this.$wording.format.attributes.name + "セットの" + this.$wording.format.name + "から選択します。";
  }

  get defaultSelectedTab(): any {
    if (this.defaultFormatTabName) {
      // URL引数でデフォルトのタブが指定されている場合
      const found = Enumerable.from(this.visibleSelectorTabs)
        .firstOrDefault(t => t.keyword === this.defaultFormatTabName);
      if (found) {
        return found;
      }
    }
    const defaultFormatTabNameFromConfiguration = this.getDefaultFormatTabNameFromConfiguration();
    if (defaultFormatTabNameFromConfiguration) {
      // フロントエンドの職種・ユーザ設定もしくはシステム共通設定で指定されている場合
      const found = Enumerable.from(this.visibleSelectorTabs)
        .firstOrDefault(t => t.keyword === defaultFormatTabNameFromConfiguration);
      if (found) {
        return found;
      }
    }
    return this.firstVisibleTab;
  }

  get firstVisibleTab(): any {
    return this.visibleSelectorTabs.some(t => t === FormatsSelector.Tabs.allFormats)
      ? FormatsSelector.Tabs.allFormats
      : this.visibleSelectorTabs[0];
  }

  private getDefaultFormatTabNameFromConfiguration(): string {
    return this.getConfigurationValue(
      this.$store.getters.extraConfiguration,
      this.$configuration,
      (c: IConfiguration) => c.behavior.format.selector.defaultSelectedTab);
  }

  /**
   * extraConfigurationへのアクセスする方法が確立したら削除予定
   */
  private getConfigurationValue<T>(extra: IConfiguration, current: IConfiguration, accessor: (configuration: IConfiguration) => T): T {
    try {
      if (extra) {
        // 現状ではextraConfigurationにDefaultConfigurationがマージされていないので、Exceptionが発生しうる
        return accessor(extra);
      }
    } catch {
    }
    return accessor(current);
  }

  createPane(tab: any): void {
    if (this.createdTabs.indexOf(tab) < 0) {
      this.createdTabs.push(tab);
    }
  }

  @Watch("selectedSelectorTab")
  onSelectedSelectorTabUpdated(newValue: any, oldValue: any): void {
    this.createPane(newValue);
    this.requestTreeNodeSelectStatus();
    this.editingSource = this.getSelectedFormats();
    this.updateSelectedSelectorTab(newValue);
    this.hashTableDirectoryPathForEachFormatUpdated(this.getHashTableDirectoryPathForEachFormat());
    this.onFormatSetSelectionChanged(this.getSelectedFormatSet());
  }

  @Watch("selectionOfAllFormats")
  onSelectionOfAllFormatsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  @Watch("selectionOfCommonDepartmentFavoriteFormats")
  onSelectionOfCommonDepartmentFavoriteFormatsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  @Watch("selectionOfDepartmentFavoriteFormats")
  onSelectionOfDepartmentFavoriteFormatsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  @Watch("selectionOfUserFavoriteFormats")
  onSelectionOfUserFavoriteFormatsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  @Watch("selectionOfAllFormatSets")
  onSelectionOfAllFormatSetsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  @Watch("selectionOfDepartmentFavoriteFormatSets")
  onSelectionOfDepartmentFavoriteFormatSetsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  @Watch("selectionOfUserFavoriteFormatSets")
  onSelectionOfUserFavoriteFormatSetsUpdated(newValue: any, oldValue: any): void {
    this.editingSource = this.getSelectedFormats();
  }

  allHashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.selectionOfAllHashTableDirectoryPathForEachFormat = value;
    this.hashTableDirectoryPathForEachFormatUpdated(this.getHashTableDirectoryPathForEachFormat());
  }

  commonDepartmentHashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.selectionOfCommonDepartmentFavoriteHashTableDirectoryPathForEachFormat = value;
    this.hashTableDirectoryPathForEachFormatUpdated(this.getHashTableDirectoryPathForEachFormat());
  }

  departmentHashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.selectionOfDepartmentFavoriteHashTableDirectoryPathForEachFormat = value;
    this.hashTableDirectoryPathForEachFormatUpdated(this.getHashTableDirectoryPathForEachFormat());
  }

  userHashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.selectionOfUserFavoriteHashTableDirectoryPathForEachFormat = value;
    this.hashTableDirectoryPathForEachFormatUpdated(this.getHashTableDirectoryPathForEachFormat());
  }

  get filterFormat(): (source: FormatReference | Directory<string, FormatReference>) => boolean {
    return this.createFormatFilter(this.formatFilter);
  }

  createFormatFilter(source: FormatReferenceTreeFilterParameter): (source: FormatReference | Directory<string, FormatReference>) => boolean {
    return s => source.filter(s);
  }

  get filterFormatSet(): (source: FormatSet | Directory<string, FormatSet>) => boolean {
    return this.createFormatSetFilter(this.formatSetFilter);
  }

  createFormatSetFilter(source: FormatSetTreeFilterParameter): (source: FormatSet | Directory<string, FormatSet>) => boolean {
    return s => source.filter(s);
  }

  defaultTreeNodeSelected(tab: any): void {
    // ID形態が全科頻用(COMMON_xxx)と科頻用(xxx)で重なることが無いはずだが仮に重なる場合は修正が必要
    this.selectedSelectorTab = tab;
    this.editingSource = this.getSelectedFormats();
  }

  shouldCreateContent(tab: any): boolean {
    return (0 <= this.createdTabs.indexOf(tab))
        && Enumerable.from(this.visibleSelectorTabs).any(t => t.name === tab.name);
  }

  shouldShowContent(tab: any): boolean {
    return this.selectedSelectorTab
      && (this.selectedSelectorTab.name === tab.name);
  }

  requestTreeNodeSelectStatus(): void {
    const tree = this.$refs[this.selectedSelectorTab.componentName];
    if (instanceOfICancelSelectFormatTree(tree)) {
      tree.requestTreeNodeSelectStatus();
    }
  }

  treeNodeSelectUpdated(value: boolean): void {
    this.isTreeSelecting = value;
  }

  cancelSelectFormatTree(): void {
    const tree = this.$refs[this.selectedSelectorTab.componentName];
    if (instanceOfICancelSelectFormatTree(tree)) {
      tree.cancelSelectFormatTree();
    }
  }

  expandTree(): void {
    const tree = this.$refs[this.selectedSelectorTab.componentName];
    if (instanceOfITreeExpandable(tree)) {
      tree.expandTree();
    }
  }

  collapseTree(): void {
    const tree = this.$refs[this.selectedSelectorTab.componentName];
    if (instanceOfITreeCollapsable(tree)) {
      tree.collapseTree();
    }
  }

  get isAdministratorDepartment(): boolean {
    return this.selectedDepartmentId && Enumerable.from(this.$store.getters.userAuthority.administratorDepartmentIds as string[])
      .any(d => d === this.selectedDepartmentId);
  }

  get isEditFormatTree(): boolean {
    return (this.shouldShowContent(this.userFavoriteFormatsTab) && instanceOfIEditTreeSource(this.userFavoriteFormatTreeSource)) ||
      (this.shouldShowContent(this.departmentFavoriteFormatsTab) && this.isAdministratorDepartment && this.$store.getters.userAuthority.hierarchiesEditable && instanceOfIEditTreeSource(this.departmentFavoriteFormatTreeSource)) ||
      (this.shouldShowContent(this.commonDepartmentFavoriteFormatsTab) && this.isCommonItemEditable && instanceOfIEditTreeSource(this.commonDepartmentFavoriteFormatTreeSource)) ||
      // (this.shouldShowContent(this.userFavoriteFormatSetsTab) && instanceOfIEditTreeRootSource(this.userFavoriteFormatSetTreeSource)) ||
      (this.shouldShowContent(this.departmentFavoriteFormatSetsTab) && this.isAdministratorDepartment && this.$store.getters.userAuthority.hierarchiesEditable && instanceOfIEditTreeRootSource(this.departmentFavoriteFormatSetTreeSource)) ||
      (this.shouldShowContent(this.allFormatSetsTab) && this.isCommonItemEditable && instanceOfIEditTreeRootSource(this.formatSetTreeSource));
  }

  get isCommonItemEditable(): boolean {
    return this.$store.getters.userAuthority.commonItemEditable;
  }

  async editFormatTree(): Promise<void> {
    try {
      this.$emit("editingFormat", true);
      const tree = this.$refs[this.selectedSelectorTab.componentName];
      if (instanceOfIEditFormatTree(tree)) {
        await tree.editFormatTree();
        this.editingSource = this.getSelectedFormats();
      }
    } catch (e) {
      this.$logger.debug(e);
    }
    this.$emit("editingFormat", false);
  }

  treeNodeDoubleClicked(): void {
    if (this.isFormatSetTabSelected) {
      this.onFormatSetDoubleClicked();
    } else {
      // 元々の実装がそうなっていたので呼ぶようにしているが、不要に思われる
      this.onFormatDoubleClicked();
    }
  }

  @Emit("formatDoubleClicked")
  onFormatDoubleClicked(): void {}

  @Emit("formatSetDoubleClicked")
  onFormatSetDoubleClicked(): void {}

  @Emit()
  updateSelectedSelectorTab(value: any): void {}

  @Emit("hashTableDirectoryPathForEachFormatUpdated")
  hashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {}

  formatsLoadCompleted(isShown: boolean): void {
    if (isShown) {
      if (!this.isFormatsLoadCompleted) {
        this.isFormatsLoadCompleted = true;
        this.setInitialVisibleTab();
      }
      this.selectedTabFormatsLoadCompleted();
    }
  }

  private setInitialVisibleTab() {
    if (this.formatId === null || isNaN(this.formatId)) {
      return;
    }
    const formats = this.getHashTableDirectoryPathForEachFormat();
    if (!!formats[this.formatId]) {
      return;
    }
    const firstVisibleTab = this.firstVisibleTab;
    if (this.shouldShowContent(firstVisibleTab)) {
      return;
    }
    this.$info(this.$wording.format.name + "選択", this.$wording.format.name + "が「" + this.selectedSelectorTab.name + "」タブに含まれていないため「" + firstVisibleTab.name + "」タブを表示します。");
    this.defaultTreeNodeSelected(firstVisibleTab);
  }

  @Emit("selectedTabFormatsLoadCompleted")
  selectedTabFormatsLoadCompleted(): void {}

  onAllFormatSetSelectionChanged(value: FormatSet): void {
    this.selectedFormatSetOfAllFormatSets = value;
    this.onFormatSetSelectionChanged(this.getSelectedFormatSet());
  }

  onDepartmentFavoriteFormatSetSelectionChanged(value: FormatSet): void {
    this.selectedFormatSetOfDepartmentFavoriteFormatSets = value;
    this.onFormatSetSelectionChanged(this.getSelectedFormatSet());
  }

  onUserFavoriteFormatSetSelectionChanged(value: FormatSet): void {
    this.selectedFormatSetOfUserFavoriteFormatSets = value;
    this.onFormatSetSelectionChanged(this.getSelectedFormatSet());
  }

  @Emit("formatSetSelectionChanged")
  onFormatSetSelectionChanged(value: FormatSet): void {}
}
